export default "https://cdn-static.gokick.com/assets/0b66121a981ee5d829a48c6e4fd91363599ac59b/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";